import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlAskPayBill =`${webUrlBase}api/mobile/table_orders/ask_payment`;
export const urlConfirmTableOrder =`${webUrlBase}api/mobile/table_orders/confirm`;
export const urlCancelUserOrder =`${webUrlBase}api/mobile/table_orders/cancel_user_order`;
